/* eslint-disable */

/**
 * @module
 * @exports ready
 * @description The core dispatcher for the dom ready event in javascript.
 *
 */

import { ready } from '../../common/utils';
import squareFrontEnd from '../square';
import squareBlockEditor from '../block-editor';
/**
 * @function bindEvents
 * @description Bind global event listeners here.
 *
 */
const bindEvents = () => {
	console.log( 'Binding theme events' );
};

/**
 * @function init
 * @description The core dispatcher for init across the codebase.
 *
 */

const init = () => {
	// initialize global events

	bindEvents();
	if ( wp.blocks ) {
		setTimeout( () => {
			squareBlockEditor();
		}, 5000 );
	} else {
		squareFrontEnd();
	}

	console.info(
		'Gravity Forms Square: Initialized all javascript that targeted document ready.'
	);
};

/**
 * @function domReady
 * @description Export our dom ready enabled init.
 *
 */

const domReady = () => {
	ready( init );
};

export default domReady;
